export default [
    {
        path: "dashboard",
        name: "driver-dashboard",
        component: () => import("@/views/driver/views/dashboard/DriverDashboard.vue"),
        meta: {
            section: 18,
            pageTitle: "Dashboard",
            breadcrumb: [
                {
                    text: "Dashboard",
                    active: true,
                },
            ],
        },
    },
];
